<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/notification' }">通知消息</el-breadcrumb-item>
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div style="padding: 0 20px 0px; box-sizing: boreder-box;" v-loading="loading">
        <div style="text-align: center; color: #333; font-size: 20px">{{info.pushHeadine}}</div>
        <div style="text-align: right; margin: 20px 0 30px; font-size: 14px; color: #999">{{info.pushDate}}</div>
        <div v-if="info.remarks">
          <div style="padding-bottom: 20px; line-height: 30px; padding: 0 20px;">
            <!-- 您当前有{{count}}条项目申报通过审查 -->
            <div style="text-indent: 2em;">《中国交通运输协会科学技术奖申报书》要严格按规定格式打印或铅印，大小为A4开本（高297毫米，宽210毫米）竖装。文字及图表应限定在高257毫米、宽170毫米的规格内排印，左边为装订边，宽度不小于25毫米，正文内容所有字型应为12号字，申报书及其指定附件备齐后应合装成册，《研究报告》单独装订成册，其大小规格应与申报书一致。装订后的《中国交通运输协会科学技术奖申报书》不需另加封面，附件需有标签页。</div>
            <div style="text-indent: 2em;">项目二维码：线上填报时由系统自动生成，下载打印后按要求贴在封面右上角位置。</div>
            <div style="text-indent: 2em;">示意图：</div>
            <div>
              <img src="../../assets/images/01.jpg" alt="" style="width: 49%;">
              <img src="../../assets/images/02.jpg" alt="" style="width: 49%; margin-left: 2%;">
            </div>
          </div>
          <div style="padding: 50px 20px 20px">
            <el-link type="primary" @click="handleUplaod(7)" icon="el-icon-download">下载纸质材料</el-link>
          </div>
        </div>
        <div v-else style="padding-bottom: 60px;">
          <div v-html="info.pushContent"></div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { increasedMessagePushGetDetail, increasedGetWebFiles } from '@/api/increased'
import { uploadFileDownload } from '@/api/system'
export default {
  data () {
    return {
      loading: false,
      info: {}
    }
  },
  created() {
    this.loading = true
    increasedMessagePushGetDetail({ id: this.$route.query.id }).then(res => {
      this.loading = false
      if (res.code == '000') {
        this.info = res.result
      }
    })
  },
  methods: {
    // 下载
    handleUplaod(type) {
      increasedGetWebFiles({}).then(res => {
        if (res.code == '000') {
          this.fileList = res.result
          this.download(type)
        }
      })
    },
    // 下载模板
    download(status) {
      const name = this.fileList['file' + status].remark
      uploadFileDownload({ path: this.fileList['file' + status].path }).then(res => {
        const blob = new Blob([res.data])
        // const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        const fileName = name
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    }
  }
}
</script>
